import { Injectable } from '@angular/core';

import { Observable, forkJoin, map, of } from 'rxjs';

import { IBetslipState } from '../../../../../base/store/state';
import { IFullBetslip, SlipId } from '../../../../bet-generation/models';
import { BetslipError } from '../../../errors/betslip-error';
import { SlipsValidationComposerService } from './slips-validation-composer.service';

@Injectable()
export class SlipsValidationService {
    constructor(private slipValidationComposer: SlipsValidationComposerService) {}

    validate$(fullBetslip: IFullBetslip, state: IBetslipState): Observable<Record<string, BetslipError[]>> {
        const allErrors = Object.values(fullBetslip.typeBetslips).reduce(
            (acc, betslip) => {
                const slipErrors = betslip.slips.reduce(
                    (slipAcc, slip) => {
                        const a = this.slipValidationComposer.validateSlip$(slip, betslip, state).pipe(
                            map((err) => {
                                return [slip.slipId, err] as [SlipId, BetslipError[]];
                            }),
                        );

                        return [...(slipAcc || []), a];
                    },
                    [] as Observable<[SlipId, BetslipError[]]>[],
                );

                return [...acc, ...slipErrors];
            },
            [] as Observable<[SlipId, BetslipError[]]>[],
        );

        return allErrors.length > 0
            ? forkJoin(allErrors).pipe(
                  map((item) =>
                      item.reduce(
                          (acc, errs) => {
                              return {
                                  ...acc,
                                  [errs[0]]: errs[1],
                              };
                          },
                          {} as Record<string, BetslipError[]>,
                      ),
                  ),
              )
            : of({});
    }
}
